import { useState } from 'react';
import { useVantifyContext } from 'integrations-vantify-context-providers';
import {
  getSiteDetails,
  Site,
} from 'integrations-vantify-client-services';
import { useVantifyBase } from '../useVantifyBase';
import { VantifyOperation, hookMessages } from '../common';

export function useVantifySiteDetails() {
  const { auth } = useVantifyContext();
  const { loading, error, execute, setError } = useVantifyBase();
  const [siteDetails, setSiteDetails] = useState<Site | null>(null);

  const fetchSiteDetails = async (siteId: number) => {
    if (!auth) {
      setError(e => ({
        ...e,
        [VantifyOperation.FETCH_SITE_DETAILS]:
          hookMessages.error_FETCH_SITE_DETAILS,
      }));

      return null;
    }

    const response = await execute(
      VantifyOperation.FETCH_SITE_DETAILS,
      () => getSiteDetails(auth, siteId),
      hookMessages.error_FETCH_SITE_DETAILS
    );

    if (response?.data) {
      setSiteDetails(response.data);

      return response.data;
    }

    return null;
  };

  return {
    siteDetails,
    loading,
    error,
    fetchSiteDetails,
  };
}

